import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[cdpRequiredMarker]',
    standalone: false
})
export class RequiredMarkerDirective {
    constructor(private el: ElementRef) {
        this.el.nativeElement.classList.add('hc-required-marker');
        this.el.nativeElement.innerHTML = '&nbsp*';
    }
}
